import {
  Box,
  ListItem,
  ListItemButton,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material"
import { IOrderBump } from "../../../../../core/types/OrderBump"
import numbers from "../../../../../core/functions/NumberFunctions"
import React, { useEffect, useState } from "react"
import { TPaymentMethodEnum } from "../../../../../core/types/Product"
import { EditableTypography } from "../../../../Typographys/EditableTypography"
import BpCheckbox from "../../../../Inputs/BpCheckboxGreen"

interface ICheckoutOrderBump7Prop {
  paymentInstallment: number
  paymentMethodType: number
  orderBump: IOrderBump
  onChange(orderBump: IOrderBump): void
}

const CheckoutOrderBump7 = ({
  paymentInstallment,
  paymentMethodType,
  orderBump,
  onChange,
}: ICheckoutOrderBump7Prop): JSX.Element => {
  const paymentsAccept = [
    TPaymentMethodEnum.CreditCard,
    TPaymentMethodEnum.TwoCreditCard,
    TPaymentMethodEnum.CreditCardAndPix,
  ]

  const containsInstallments =
    orderBump.installments && orderBump.installments.length > 0

  const isInstallments =
    paymentsAccept.includes(paymentMethodType) &&
    containsInstallments &&
    paymentInstallment > 1

  const value =
    orderBump.productPrice?.firstPurchasePrice ?? orderBump.productPrice?.value

  const installmentValue = isInstallments
    ? orderBump.installments?.find(
        (o) => o.installmentNumber === paymentInstallment
      )?.value
    : null

  const orderBumpValue = installmentValue ?? value

  const [typedText, setTypedText] = useState("")

  const handleClick = () => {
    orderBump.selected = !orderBump.selected
    onChange(orderBump)
  }

  const isSmallScreen = useMediaQuery((theme: any) =>
    theme.breakpoints.down("md")
  )

  useEffect(() => {
    if (orderBump.selected) {
      const fullText = "PRODUTO ADICIONADO"
      let index = 0
      setTypedText("")

      const typing = setInterval(() => {
        setTypedText((prev) => prev + fullText.charAt(prev.length))
        index++

        if (index >= fullText.length) {
          setTypedText("PRODUTO ADICIONADO")
          clearInterval(typing)
        }
      }, 50) // Velocidade da digitação

      return () => clearInterval(typing)
    } else {
      setTypedText("") // limpa se desmarcar
    }
  }, [orderBump.selected])

  return (
    <>
      <ListItem key={`ob-${orderBump.id}`} disablePadding>
        <Box sx={{ position: "relative", width: "100%" }}>
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              zIndex: 2,
              pointerEvents: "none",
              borderRadius: "20px",
              background:
                "radial-gradient(circle at center, rgba(255,255,255,0.4) 0%, rgba(62,191,144,0.2) 80%)",
              backdropFilter: "blur(1.2px)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "opacity 0.3s ease",
              opacity: orderBump.selected ? 1 : 0,
              m: 0.3,
              mb: 2.3,
            }}
          >
            <Typography
              fontSize="18px"
              fontWeight={600}
              color="#3ebf90"
              sx={{ zIndex: 3 }}
            >
              {typedText}
            </Typography>
          </Box>
          <ListItemButton
            dense
            role={undefined}
            className="listItemButtonOrderBump"
            onClick={handleClick}
            sx={{
              p: 2,
              borderRadius: "20px",
              mb: 2,
              border: "2px dashed #3ebf90",
            }}
          >
            <Stack direction={"column"} width="100%">
              <Box
                sx={{
                  width: "100%",
                  backgroundColor: "#fbfbfb",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "white",
                  borderRadius: "10px",
                  //border: "2px dashed #3ebf90",
                  //borderBottom: "0px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
                padding={1}
              >
                <Stack
                  width="100%"
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{ pr: 1 }}
                >
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Box>
                      <BpCheckbox checked={orderBump.selected ?? false} />
                    </Box>
                    <Typography
                      variant="h5"
                      fontWeight={500}
                      fontFamily="Montserrat"
                      fontSize="14px"
                      lineHeight="14px"
                      color="#3ebf90"
                    >
                      {/*orderBump.title*/}
                      Adicionar receitas!
                    </Typography>
                  </Stack>
                  <Typography
                    variant="h5"
                    fontWeight={600}
                    fontFamily="Montserrat"
                    fontSize="14px"
                    lineHeight="14px"
                    color="#3ebf90"
                  >
                    {numbers.formatMoneyDefault(orderBumpValue)}
                  </Typography>
                </Stack>
              </Box>

              <Stack
                sx={{
                  backgroundColor: "transparent",
                }}
              >
                <Box p={{ xs: 2, sm: 2 }}>
                  <Box
                    sx={{
                      backgroundColor: "transparent",
                      gap: "8px",
                      borderRadius: "10px",
                    }}
                  >
                    <Box width="100%" sx={{ flexGrow: 1, display: "flex" }}>
                      <Box width="100%">
                        <Stack
                          direction={{ xs: "column", sm: "row" }}
                          sx={{ width: "100%", pl: { xs: 0, sm: 1 }, pr: 1 }}
                          alignItems={{ xs: "center", sm: "start" }}
                          gap={{ xs: "0px", sm: "12px" }}
                        >
                          <Box
                            sx={{
                              borderRadius: "8px",
                              mt: 1,
                            }}
                          >
                            {orderBump.productPrice?.product?.coverUrl &&
                              orderBump.productPrice?.product?.coverUrl !==
                                "" && (
                                <img
                                  src={
                                    !orderBump.productPrice?.product?.coverUrl
                                      ? `${process.env.PUBLIC_URL}/top.png`
                                      : orderBump.productPrice.product.coverUrl
                                  }
                                  alt={orderBump.productPrice?.product?.name}
                                  style={{
                                    height: isSmallScreen ? 150 : 150,
                                    width: isSmallScreen ? 150 : 150,
                                    objectFit: "cover",
                                    borderRadius: "8px",
                                  }}
                                />
                              )}
                          </Box>
                          <Stack
                            direction={"column"}
                            spacing={1}
                            sx={{ flexGrow: 1, width: "100%", pt: 1 }}
                          >
                            {/*<Typography
                            variant="h5"
                            fontFamily="Montserrat"
                            fontSize="12px"
                            lineHeight="20px"
                            fontWeight={400}
                            color="rgba(56, 57, 59, 1)"
                          >
                            <EditableTypography
                              htmlContent={orderBump.description ?? ""}
                            />  
                          </Typography>*/}
                            <Typography
                              variant="h5"
                              fontFamily="Montserrat"
                              fontSize="16px"
                              lineHeight="20px"
                              fontWeight={600}
                              color="#343948"
                            >
                              {orderBump.title}
                            </Typography>
                          </Stack>
                        </Stack>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Stack>
            </Stack>
          </ListItemButton>
        </Box>
      </ListItem>
    </>
  )
}

export default CheckoutOrderBump7
